
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and 
// compiles into the necessary css files
require('../scss/index.scss');

require('./components/navigation.js');
require('./components/documents.js');
require('./global/effects.js');
require('./global/toggles-switches.js');
